import New from './components/New'
import Edit from './components/Edit'
import Dashboard from './components/Dashboard'
import Summary from './components/Summary'
import Editor from './components/Editor'
import FixedCostItems from './components/FixedCostItems'

export const routes = [
  {
    path: '/',
    redirect: { name: 'dashboard' }
  }, {
    path: '/new',
    name: 'new',
    component: New
  }, {
    path: '/edit',
    name: 'edit',
    component: Edit
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  }, {
    path: '/summary',
    name: 'summary',
    component: Summary
  }, {
    path: '/editor',
    name: 'editor',
    component: Editor
  }, {
    path: '/fixed_cost_items',
    name: 'fixed_cost_items',
    component: FixedCostItems
  }, {
    path: '*',
    redirect: { name: 'dashboard' }
  }
]



// WEBPACK FOOTER //
// ./src/router-config.js